var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-editor-main"},[_c('quill-editor',{staticClass:"my-editor",attrs:{"options":_vm.editorOptions,"disabled":_vm.isDisabled},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }